import type { ImportDesignerDryRun } from '@today/types'

/** Props for {@link DryRunSummary}. @property dryRun - The dry-run response. */
export interface DryRunSummaryProps {
	dryRun: ImportDesignerDryRun
}

/**
 * The planned counts of a dry-run (TO-400 SCN-005), or why there is no plan.
 * The counts read the sample as if it were the whole file. Pure.
 */
export function DryRunSummary({ dryRun }: DryRunSummaryProps) {
	const { plan, validation } = dryRun
	if (!plan) {
		return (
			<p role="alert" className="text-ds-sm text-ds-danger">
				The sample does not pass validation ({validation.outcome}
				{validation.failedStage ? ` at ${validation.failedStage}` : ''}), so nothing was planned.
			</p>
		)
	}
	return (
		<div className="flex flex-col gap-1 text-ds-sm text-ds-text">
			<p role="status">
				{`${plan.created} created · ${plan.updated} updated · ${plan.unchanged} unchanged · ${plan.deactivated} deactivated · ${plan.invalid} invalid`}
			</p>
			{validation.totals.rejectedRecords > 0 && (
				<p>{validation.totals.rejectedRecords} records were rejected by validation and are not in the plan.</p>
			)}
			{plan.wouldRejectFile && (
				<p role="alert" className="text-ds-danger">
					The owner refuses {plan.invalid} entries, so this file would be rejected.
				</p>
			)}
			<p>These counts treat the sample as the whole file: current records missing from it count as missing.</p>
		</div>
	)
}
